module.exports = __webpack_public_path__ + "resource/img/video_close.png?9338e5db8d0f9ca69d5e52f26ee076fd";


//////////////////
// WEBPACK FOOTER
// ./src/images/video_close.png
// module id = 448
// module chunks = 36